


























import { Component, Vue } from "vue-property-decorator";
import Popup from "../popup/popup.vue";
import CzIcon from "../cz/CzIcon.vue";
import CzNotice from "../cz/CzNotice.vue";
import { GuidelineApi } from "./guidelineApi";

// From "Today" the patient writes to the team about a guideline that allows it (D12), picking which;
// each one keeps the conversation in its Messages tab.
@Component({ components: { Popup, CzIcon, CzNotice } })
export default class WriteToProfessional extends Vue {
  topics: any[] = [];
  showing = false;
  topicKey = "";
  text = "";
  error = "";
  sending = false;
  sent = false;

  key(t: any): string {
    return `${t.customerGuidelineId}`;
  }

  async mounted() {
    const res = await GuidelineApi.messageTopics();
    this.topics = res && res.ok ? res.model : [];
  }

  open() {
    this.topicKey = this.key(this.topics[0]);
    this.text = "";
    this.error = "";
    this.sent = false;
    this.showing = true;
  }

  async send() {
    if (this.sending) return;
    const topic = this.topics.find((t: any) => this.key(t) === this.topicKey);
    this.sending = true;
    const res = await GuidelineApi.sendMessage({
      customerGuidelineId: topic.customerGuidelineId,
      text: this.text,
    }).catch(() => null);
    this.sending = false;
    if (!res || !res.ok) {
      this.error = (res && res.errorMsg) || this.$t("It could not be sent. Try again").toString();
      return;
    }
    this.sent = true;
  }
}
